export default "__VITE_ASSET__824dcb08__"